(function () {
  function money(cents) {
    if (cents % 100 === 0) return (cents / 100) + ' zł';
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  function initBar(bar) {
    var sectionId = bar.getAttribute('data-section-id');
    var pill = bar.querySelector('[data-taio-sticky-button]');
    var priceEl = bar.querySelector('[data-taio-sticky-price]');
    if (!pill) return;

    var mainSubmit = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!mainSubmit) {
      var info = document.getElementById('ProductInfo-' + sectionId);
      if (info) mainSubmit = info.querySelector('.product-form__submit');
    }

    function positionPill() {
      if (!mainSubmit || !window.matchMedia('(min-width: 750px)').matches) {
        bar.classList.remove('taio-sticky-atc--aligned');
        pill.style.left = '';
        pill.style.width = '';
        pill.style.height = '';
        pill.style.fontSize = '';
        pill.style.fontWeight = '';
        pill.style.letterSpacing = '';
        pill.style.textTransform = '';
        pill.style.fontFamily = '';
        return;
      }
      var rect = mainSubmit.getBoundingClientRect();
      var typoSource = mainSubmit.querySelector('.button__text');
      if (!typoSource) {
        var spans = mainSubmit.querySelectorAll('span');
        for (var i = 0; i < spans.length; i++) {
          if (spans[i].textContent.trim().length > 0) {
            typoSource = spans[i];
            break;
          }
        }
      }
      if (!typoSource) typoSource = mainSubmit;
      var ts = window.getComputedStyle(typoSource);
      bar.classList.add('taio-sticky-atc--aligned');
      pill.style.left = rect.left + 'px';
      pill.style.width = rect.width + 'px';
      pill.style.height = rect.height + 'px';
      pill.style.fontSize = ts.fontSize;
      pill.style.fontWeight = ts.fontWeight;
      pill.style.letterSpacing = ts.letterSpacing;
      pill.style.textTransform = ts.textTransform;
      pill.style.fontFamily = ts.fontFamily;
    }

    positionPill();
    window.addEventListener('resize', positionPill);
    window.addEventListener('load', positionPill);

    var alwaysVisible = bar.hasAttribute('data-taio-sticky-always');
    if (!alwaysVisible && mainSubmit && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('taio-sticky-atc--hidden', entry.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(mainSubmit);
    }

    pill.addEventListener('click', function (e) {
      var juo = document.getElementById('juo-subscription-widget');
      if (juo && juo.classList.contains('taio-juo')) {
        e.preventDefault();
        var top = juo.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });

    var hasJuo = !!document.querySelector('#juo-subscription-widget.taio-juo');
    if (hasJuo || !priceEl) return;

    var dataEl = bar.querySelector('[data-taio-sticky-variants]');
    if (!dataEl) return;
    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }

    var form = document.getElementById('product-form-' + sectionId);
    if (!form) return;
    var lastId = '';

    function sync() {
      var input = form.querySelector('input[name="id"]');
      if (!input) return;
      var id = String(input.value || '');
      if (!id || id === lastId) return;
      lastId = id;
      var v = variants[id];
      if (!v) return;
      priceEl.textContent = money(v.price);
      pill.disabled = !v.available;
    }

    sync();
    setInterval(sync, 300);
  }

  function init() {
    document.querySelectorAll('[data-taio-sticky]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();